import { Institution } from '@borg/types';

class InstitutionsService {
  search = (query: string) =>
    serviceHttpGetFactory<Institution[]>(`/apps/institutions?search=${query}`);
}

export const institutionsService = new InstitutionsService();
